import { render, staticRenderFns } from "./UserGuaranteedDetails.vue?vue&type=template&id=60cb36d4&scoped=true&"
import script from "./UserGuaranteedDetails.vue?vue&type=script&lang=js&"
export * from "./UserGuaranteedDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserGuaranteedDetails.vue?vue&type=style&index=0&id=60cb36d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cb36d4",
  null
  
)

export default component.exports